import { useState } from "react";
import { LEGAL_DOCS, LEGAL_META, type LegalDocId } from "./legal";
import { useGame } from "./store";

export function LegalPanel() {
  const panel = useGame((s) => s.panel);
  const setPanel = useGame((s) => s.setPanel);
  const [doc, setDoc] = useState<LegalDocId>("impressum");

  if (panel !== "legal") return null;

  const current = LEGAL_DOCS.find((d) => d.id === doc)!;

  return (
    <div className="modal-backdrop" onClick={() => setPanel(null)}>
      <div className="modal station-modal detail-xl" onClick={(e) => e.stopPropagation()}>
        <header>
          <div>
            <h2>Rechtliches</h2>
            <p className="muted small" style={{ margin: "4px 0 0" }}>
              {LEGAL_META.productName} · Stand {LEGAL_META.lastUpdated} · Platzhalter vor Live-Gang
            </p>
          </div>
          <button className="btn ghost" type="button" onClick={() => setPanel(null)}>
            Schließen
          </button>
        </header>
        <div className="detail-layout">
          <nav className="detail-nav">
            {LEGAL_DOCS.map((d) => (
              <button
                key={d.id}
                type="button"
                className={doc === d.id ? "active" : ""}
                onClick={() => setDoc(d.id)}
              >
                {d.title}
              </button>
            ))}
          </nav>
          <div className="detail-main legal-doc">
            <h3 style={{ marginTop: 0 }}>{current.title}</h3>
            {current.body.map((p, i) => (
              <p key={i} className={i === 0 ? "" : "muted"} style={{ lineHeight: 1.5 }}>
                {p}
              </p>
            ))}
            <p className="muted small" style={{ marginTop: 20 }}>
              Keine Rechtsberatung. Vor öffentlicher Veröffentlichung Angaben und Texte durch den
              Betreiber ersetzen und rechtlich prüfen lassen. Siehe auch LEGAL.md im Projekt.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
